import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const Image = (props) => {
  const {
    id,
    src,
    alt,
    className,
    objectFit,
  } = props;

  return (
    <S.Image
      id={id}
      src={src}
      alt={alt}
      className={className}
      objectFit={objectFit}
    />
  );
};

Image.propTypes = {
  id: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  objectFit: PropTypes.string,
};

Image.defaultProps = {
  className: '',
  objectFit: null,
};

export default Image;
